import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, Inject, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import {
    ApiRequestService,
    DialogService,
    FileexplorerComponent,
    MAT_ICON,
    MetaComponent,
    MetaService,
    TinyMCEHtmlEditorComponent,
    TOAST_STATE,
    ToastmessageService,
    TranslationService
} from '@prekog/common-ui';
import { map, Observable, switchMap } from 'rxjs';
import { GetSpecialitiesResponse } from '../../specialitypricelist/getspecialitiesresponse';
import { AddconsultinghourDialogComponent } from '../addconsultinghourdialog.ts/addconsultinghourdialog.ts.component';
import { AddConsultingHourDialogResult } from '../addconsultinghourdialog.ts/addconsultinghourdialogresult';
import { Speciality } from '../addjobtitle/speciality';
import { Doctor } from '../doctor';
import { DoctorConsultingHour } from '../updatedoctor/doctorconsultinghour';
import { UploadFileResponse } from '../updatedoctor/uploadfileresponse';
import { AddDoctorRequest } from './adddoctorrequest';
import { SpecialityWithChecked } from './specialitywithchecked';
@Component({
    selector: 'app-adddoctor',
    templateUrl: './adddoctor.component.html',
    styleUrls: ['./adddoctor.component.scss'],
    standalone: true,
    imports: [
        MatIconModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        MatCheckboxModule,
        TinyMCEHtmlEditorComponent,
        FileexplorerComponent,
        MetaComponent
    ]
})
export class AdddoctorComponent implements OnInit {
    addDoctorUrl = '/admin/add-doctor';

    baseRegeneroUrl = '';

    consultationHourForm?: FormGroup;

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };

    doctor: Doctor = {};

    doctorConsultingHour: DoctorConsultingHour = {};

    doctorConsultingHoursList: DoctorConsultingHour[] = [];

    doctorForm?: FormGroup;

    downloadFileUrl = '';

    downloadUri = '';

    enterAnimationDuration = '500ms';

    errorMessageCover = 'Kérem válassza ki az orvoshoz tartozó képeket!';

    exitAnimationDuration = '200ms';

    fileBaseUrl = '';

    fileCover: File | null = null;

    @ViewChild('fileCoverInput') fileCoverInput!: ElementRef;

    getSpecialitiesUrl = '/regenero/get-all-specialities';

    htmlForm?: FormGroup;

    id = 0;

    maxFileSize = 5000000;
    regeneroBaseUrl = '';
    specialities?: Speciality[];
    specialityWithCheckedList?: SpecialityWithChecked[];
    uploadCoverFile = false;
    uploadFileUrl = '/admin/uploadFile';
    doctorUrlPrefix = '/doctor';
    private _metaService = inject(MetaService);
    get isFormValid(): boolean {
        return !!this.doctorForm?.valid && !!this.htmlForm?.valid;
    }

    private _dialogService = inject(DialogService);

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('DOWNLOAD_FILE_URL') private _downloadFileUrl: string,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _toastMessageService: ToastmessageService,
        private _fb: FormBuilder,
        @Inject('FILE_MANAGER_URL') private _fileManagerUrl: string,
        private _translateService: TranslationService,
        @Inject('PUBLIC_UI_URL') private _publicUiUrl: string
    ) {
        this.downloadFileUrl = _downloadFileUrl;
        this.regeneroBaseUrl = _regeneroBaseUrl;
        this.fileBaseUrl = _fileManagerUrl;
        this.createDoctorForm();
        this.createConsultationHourForm();
        this.createHtmlForm();
        this.baseRegeneroUrl = this._publicUiUrl;
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else {
            this.getSpecialities();
        }
    }

    getSpecialities() {
        this._apiRequestService
            .sendRequest<{}, GetSpecialitiesResponse>(this.regeneroBaseUrl, {}, true, this.getSpecialitiesUrl)
            .subscribe((response) => {
                const specialityWithCheckedList: SpecialityWithChecked[] = [];
                this.specialities = response.specialityList;
                this.specialities?.forEach((speciality) => {
                    if (!speciality.isSpeciality) {
                        const index = this.specialities?.indexOf(speciality);
                        this.specialities?.splice(index!, 1);
                    } else {
                        const specialityWithChecked: SpecialityWithChecked = {
                            speciality: speciality,
                            checked: false
                        };

                        specialityWithCheckedList.push(specialityWithChecked);
                    }
                    this.specialityWithCheckedList = [...specialityWithCheckedList];
                });
            });
    }

    createDoctorForm() {
        this.doctorForm = this._fb.group({
            name: ['', [Validators.required]],
            reservationLink: ['', [Validators.required]],
            routerLink: ['', [Validators.required]]
        });
    }

    createHtmlForm() {
        this.htmlForm = this._fb.group({
            html: ['', [Validators.required]]
        });
    }

    createConsultationHourForm() {
        this.consultationHourForm = this._fb.group({
            day: ['', [Validators.required]],
            startTime: ['', [Validators.required]],
            endTime: ['', [Validators.required]]
        });
    }

    removeConsultingHour(index: number) {
        this.doctorConsultingHoursList.splice(index, 1);
    }

    onChange(event: Event) {
        const target = event.target as HTMLInputElement;
        this.fileCover = target.files![0];
        if (this.fileCover.name.split('.').pop() === 'jpg' || 'png' || 'JPEG' || 'jpeg') {
            this.uploadCoverFile = true;
        } else {
            this.uploadCoverFile = false;
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.warning,
                'Kérem ".jpg" vagy ".png" kiterjesztésű fájlt töltsön fel!',
                MAT_ICON.warning
            );
            this.dismissError();
        }
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    clearSelectedCoverFile() {
        this.fileCoverInput.nativeElement.value = null;
        this.uploadCoverFile = false;
    }

    changeJobTitle(specialityWith: SpecialityWithChecked) {
        this.specialityWithCheckedList?.forEach((specialityWithCheck) => {
            if (specialityWith.speciality?.jobTitle === specialityWithCheck.speciality?.jobTitle) {
                specialityWithCheck.checked = !specialityWithCheck.checked;
            }
        });
    }

    openAddConsultingHourDialog() {
        this._dialogService
            .openDialog(
                AddconsultinghourDialogComponent,
                null,
                ((addConsultingHourDialogResult: AddConsultingHourDialogResult | undefined) => {
                    if (addConsultingHourDialogResult?.doctorConsultingHour) {
                        this.doctorConsultingHoursList = [...this.doctorConsultingHoursList, addConsultingHourDialogResult.doctorConsultingHour];
                    }
                }
                )
            )
    }


    collectDoctorData() {
        this.doctor = {
            name: this.doctorForm?.controls['name'].value as string | undefined,
            introduction: this.htmlForm?.controls['html'].value as string | undefined,
            reservationLink: this.doctorForm?.controls['reservationLink'].value as string | undefined,
            image: this.downloadUri,
            routerLink: this.doctorForm?.controls['routerLink'].value as string | undefined
        };
    }

    collectJobTitles(): string[] {
        const jobTitleList: string[] = [];

        this.specialityWithCheckedList?.forEach((specialityWithChecked) => {
            if (specialityWithChecked.checked) {
                jobTitleList.push(specialityWithChecked.speciality?.jobTitle!);
            }
        });

        return jobTitleList;
    }

    addDoctor() {
        if (!this.uploadCoverFile) {
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, this.errorMessageCover, MAT_ICON.warning);
            this.dismissError();
            return;
        }

        if (this.fileCover?.size! > this.maxFileSize) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('file.maxSize'),
                MAT_ICON.error
            );
            this.dismissError();
            return;
        }

        this.uploadDoctorImage()
            .pipe(switchMap(() => this.addDoctorPart()))
            .subscribe(() => {
                if (this._metaService.canSaveMeta(false)) {
                    this._metaService.saveMetaTag(false, this.doctor.routerLink!, this.doctor.image!);
                }
                this._router.navigateByUrl('/doctors');
            });
    }

    uploadDoctorImage(): Observable<any> {
        const fileCoverObservable = this._apiRequestService.uploadFile(this.fileCover!, true, this.fileBaseUrl, this.uploadFileUrl);
        return fileCoverObservable.pipe(
            map((fileCover) => {
                const fileCoverResponse = fileCover as UploadFileResponse;
                this.downloadUri = fileCoverResponse.downloadUri as string;
            })
        );
    }

    addDoctorPart(): Observable<HttpResponse<any>> {
        this.collectDoctorData();

        const addDoctorRequest: AddDoctorRequest = {
            doctor: this.doctor,
            doctorConsultingHourList: this.doctorConsultingHoursList,
            jobTitleList: this.collectJobTitles()
        };

        return this._apiRequestService.sendRequest<AddDoctorRequest, HttpResponse<any>>(
            this.regeneroBaseUrl,
            addDoctorRequest,
            true,
            this.addDoctorUrl,
            true
        );
    }
}
